<template>
  <div class="grid-details-qualitys">
    <v-row no-gutters class="justify-space-between f-width">
      <div class="d-grid align-center">
        <span
          class="body-bold-small neutral-20-dark--text"
          v-if="status == 'CONVERTING'"
          >{{
            isReplacing
              ? $t('message.pages.videoPage.details.alert.replacing.title')
              : $t('message.pages.videoPage.details.alert.converting.title')
          }}</span
        >
        <span
          class="body-bold-small neutral-20-dark--text"
          v-if="status == 'DRAFT'"
          >{{
            isReplacing
              ? $t(
                  'message.pages.videoPage.details.alert.replacing.description'
                )
              : $t(
                  'message.pages.videoPage.details.alert.converting.titleWaiting'
                )
          }}</span
        >
        <span
          class="body-regular-smaller neutral-40-light--text"
          v-if="status == 'CONVERTING' && isReplacing"
          >{{
            $t('message.pages.videoPage.details.alert.replacing.description')
          }}</span
        >
        <span
          class="body-regular-smaller neutral-40-light--text"
          v-if="status == 'CONVERTING' && !isReplacing && estimatedTime != 0"
          >{{
            $t(
              'message.pages.videoPage.details.alert.converting.timeEstimated',
              {
                time: estimatedTime || video.estimated_time,
              }
            )
          }}</span
        >
        <span
          class="body-regular-smaller neutral-40-light--text"
          v-else-if="status == 'DRAFT' && !isReplacing && estimatedTime != 0"
          >{{
            isReplacing
              ? $t(
                  'message.pages.videoPage.details.alert.replacing.description'
                )
              : $t(
                  'message.pages.videoPage.details.alert.converting.timeWaiting',
                  {
                    time: estimatedTime,
                  }
                )
          }}</span
        >
      </div>
      <base-btn
        size="small"
        type="secondary"
        class="converting-alert-btn"
        @click="goToConversionArticle"
        >{{ $t('message.pages.videoPage.details.alert.converting.action')
        }}<v-icon class="body-bold-smaller pl-2" size="20"
          >mdi-open-in-new</v-icon
        ></base-btn
      >
    </v-row>
    <div class="d-flex justify-space-between align-center f-width mt-8">
      <span class="body-regular-small neutral-40-light--text"
        >Backup Original</span
      >
      <quality-status
        :status="video.backup ? 'available' : 'disabled'"
      ></quality-status>
    </div>
    <div v-for="item of allQualitys" :key="item" class="f-width">
      <v-divider class="f-width my-4"></v-divider>
      <div class="d-flex justify-space-between align-center">
        <span
          class="body-regular-small neutral-40-light--text"
          :class="{ 'neutral-70--text': checkStatus(item) == 'disabled' }"
          >{{ item }}</span
        >
        <quality-status
          :status="checkStatus(item)"
          :isQualityScreen="isQualityScreen"
        ></quality-status>
      </div>
    </div>
  </div>
</template>
<script>
import QualityStatus from './QualityStatus.vue'
import axios from 'axios'
export default {
  components: { QualityStatus },
  name: 'QualitysConverting',
  data: () => ({
    allQualitys: ['240p', '360p', '480p', '720p', '1080p', '1440p', '2160p'],
    qualityWithErrors: [],
  }),
  props: {
    video: {
      type: Object,
      default: () => ({}),
    },
    isReplacing: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: 'CONVERTING',
    },
    estimatedTime: {
      type: String,
      default: '0',
    },
    encodingResolutions: {
      type: Array,
      default: () => [],
    },
    pendingResolutions: {
      type: Array,
      default: () => [],
    },
    availableResolutions: {
      type: Array,
      default: () => [],
    },
    isQualityScreen: {
      type: Boolean,
    },
  },
  computed: {
    encoding_resolutions() {
      return this.encodingResolutions
    },
    pending_resolutions() {
      return this.pendingResolutions
    },
    available_resolutions() {
      return this.availableResolutions
    },
  },
  methods: {
    inProgress(quality) {
      return (
        this.pending_resolutions?.includes(quality) &&
        this.pending_resolutions[0] === quality
      )
    },
    isWaiting(quality) {
      return (
        this.pending_resolutions?.includes(quality) &&
        this.pending_resolutions[0] !== quality
      )
    },
    withError(quality) {
      return this.qualityWithErrors.includes(quality)
    },
    isStaging() {
      return !!window.location.host.match(/stg.dashboard|localhost/)
    },
    isAvailable(quality) {
      return (
        this.available_resolutions?.includes(quality) &&
        this.encoding_resolutions?.includes(quality)
      )
    },
    async handleCheckAllFormatsM3u8() {
      if (
        this.video.drm_group_ids &&
        this.video.drm_group_ids.some((row) => row.active)
      )
        return
      const formats = this.allQualitys.filter((quality) =>
        this.isAvailable(quality)
      )
      for (let i in formats) {
        let ret = ''
        const isStaging = this.isStaging() ? '.stg' : ''
        let endpoint = `https://b-${this.video.pullzone_name}${isStaging}.tv.pandavideo.com.br/${this.video.video_external_id}/${formats[i]}/video.m3u8`

        try {
          ret = await axios.get(endpoint)
          console.log(ret)
        } catch (error) {
          console.log(error)
        }
        if (ret.status !== 200 || ret.status !== 302) {
          this.qualityWithErrors.push(formats[i])
        }
      }
      this.testingM3u8 = false
    },
    checkStatus(quality) {
      if (this.withError(quality) && this.isAvailable(quality)) return 'error'
      if (this.withError(quality) && this.isQualityScreen) return 'error'
      if (this.isAvailable(quality)) return 'available'
      if (this.inProgress(quality)) return 'progress'
      if (this.isWaiting(quality)) return 'waiting'
      return 'disabled'
    },
    goToConversionArticle() {
      const articleLinks = {
        en: 'https://help.pandavideo.com/en-us/article/video-taking-too-long-to-convert-ouw4ho/',
        es: 'https://help.pandavideo.com/es/article/tu-video-tarda-demasiado-en-convertirse-s83y2g/',
        pt: 'https://help.pandavideo.com/pt-br/article/video-demorando-demais-para-converter-1uvumg4/',
      }
      const locale = this.$i18next.resolvedLanguage
      window.open(articleLinks[locale], '_blank')
    },
  },

  async mounted() {},
}
</script>
<style lang="scss" scoped>
.grid-details-qualitys {
  display: flex;
  padding: var(--spacing-07, 24px);
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  background: varFigma(neutral-100-white);
  border: 1px solid varFigma(neutral-95-lightest);
  border-radius: var(--spacing-02, 4px);
  margin-top: 24px;
}
.d-grid {
  display: grid;
}
.neutral-70--text {
  color: #abadba;
}
.bg-dark {
  .neutral-70--text {
    color: #666d99;
  }
}
</style>
